import { botClient, makeServicePlugin, BaseModel } from '@/bot'

class Information extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Information'
  // Define default properties here
  static instanceDefaults() {
    return {
      name: "",
      description: "",
      slug: "",
      message: "",
      groups: [],
      members_only: true,
      properties: {
        order: 0
      }
    }
  }
}

const servicePath = 'information'
const servicePlugin = makeServicePlugin({
  Model: Information,
  service: botClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
botClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin